/**
 *
 * subnav state selectors
 *
 */

import { createSelector } from 'reselect';
import { SUBNAV_KEY } from './subnav-constants';

const selectSubnav = (state) => state[SUBNAV_KEY];

const makeSelectSubnavTopics = () =>
    createSelector(
        selectSubnav,
        (subnavState) => subnavState.menuItems
    );

export {
    selectSubnav,
    makeSelectSubnavTopics,
};
